import { Box, xxlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent, useState } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import {
  isPaymentMethod,
  PaymentMethod,
  PaymentScheduleConfig,
} from '../../../../state/configuration'
import { FullPage } from '../../../templates'
import { useProduct } from '../../ProductProvider'
import { ProposalSidebarPricing } from '../pricing'
import { useProposal } from '../ProposalProvider'
import {
  PaymentCard,
  PaymentDirectDebit,
  PaymentDual,
  PaymentMethods,
} from './components'

const tKey = TKey('pages.payment-user')

export interface PaymentPageProps {
  config: PaymentScheduleConfig
}

export const PaymentPage: FunctionComponent<PaymentPageProps> = ({ config }) => {
  const { t } = useWriskTranslation()

  const { proposal } = useProposal()
  const { product } = useProduct()

  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>(() => {
    const context = new URLSearchParams(window.location.search).get('context')
    return isPaymentMethod(context) ? context : config.paymentMethods[0]
  })

  const paymentComponent = (() => {
    switch (paymentMethod) {
      case 'CARD':
        return <PaymentCard config={config} />
      case 'DIRECT_DEBIT':
        return <PaymentDirectDebit config={config} paymentMethod={paymentMethod} />
      case 'DUAL':
        return <PaymentDual config={config} paymentMethod={paymentMethod} />
    }
  })()

  return (
    <FullPage pageId='payment-page' header={t(tKey('header'))}>
      <Box display='flex' rowGap={xxlBumps} flexDirection='column' width={1}>
        <Box variant='raised' width={1}>
          <ProposalSidebarPricing proposal={proposal} product={product} />
        </Box>

        {config.paymentMethods.length > 1 && (
          <PaymentMethods
            options={config.paymentMethods}
            value={paymentMethod}
            onChange={setPaymentMethod}
          />
        )}

        {paymentComponent}
      </Box>
    </FullPage>
  )
}
